var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 29.3906H20.625",
    stroke: "#3A3A3A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24524 13.4063C7.24353 12.1832 7.48391 10.9719 7.95252 9.84223C8.42114 8.71251 9.10871 7.68672 9.97562 6.82397C10.8425 5.96123 11.8716 5.27859 13.0036 4.81542C14.1355 4.35225 15.348 4.11771 16.571 4.1253C21.6744 4.16324 25.7564 8.40516 25.7564 13.5228V13.9219C25.7564 18.5388 26.7223 21.2179 27.5731 22.6821C27.6647 22.8386 27.7135 23.0165 27.7145 23.1978C27.7154 23.3791 27.6686 23.5575 27.5786 23.7149C27.4886 23.8723 27.3588 24.0033 27.202 24.0945C27.0453 24.1857 26.8673 24.234 26.686 24.2344H6.31461C6.13327 24.2339 5.95525 24.1857 5.79853 24.0944C5.6418 24.0032 5.51191 23.8723 5.42195 23.7148C5.33199 23.5573 5.28515 23.3789 5.28615 23.1976C5.28715 23.0162 5.33596 22.8384 5.42765 22.6819C6.27886 21.2176 7.24523 18.5385 7.24523 13.9219L7.24524 13.4063Z",
    stroke: "#3A3A3A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSymbol);
export default __webpack_public_path__ + "static/media/bellSymbol.3da57c849a9349e953cc385adc422de3.svg";
export { ForwardRef as ReactComponent };